import { MENU_HOME, PAGE_MYPROFILE } from './router/routes';

function getEnv(key) {
  return window.__ENV__[key];
}

export const TITLE = 'HR Management System'
export const URL_PROFILE = 'https://portal.skyict.co.th/time_sheet'
export const LOGOUT = 'LOGOUT'
export const TOKEN = 'TOKEN'
export const RETOKEN = 'RETOKEN'
export const PROFILE = 'PROFILE'
export const REMEMBER = 'REMEMBER'
export const ID_DETAIL = 'DETAIL'
export const DATE_LOGIN = 'DATE_LOGIN'
export const BODY = 'BODY'
export const PAGE = 'PAGE'
export const BODYCLN = 'BODYCLN'
export const PAGECLN = 'PAGECLN'
export const BODYCLR = 'BODYCLR'
export const PAGECLR = 'PAGECLR'
export const BODYEXPAND = 'BODYEXPAND'
export const SEARCHEXPAND = 'SEARCHEXPAND'
export const BODYCONTRACT = 'BODYCONTRACT'
export const PAGECONTRACT = 'PAGECONTRACT'

export const ALLMENU = 'ALLMENU'
export const SEARCHORGRIGHT = 'SEARCHORGRIGHT'
export const BODYORGRIGHT = 'BODYORGRIGHT'
export const PAGEORGRIGHT = 'PAGEORGRIGHT'
export const MODE = 'MODE'
export const USERORG = 'USERORG'
export const TXTSUCCESS = 'Your work has been saved'

export const API_URL = `${getEnv("REACT_APP_API_URL")}`
export const AUTH = `${getEnv("REACT_APP_AUTHEN")}`

export const API_LNK = `${getEnv("REACT_APP_API_LNK")}`
export const KEY_LNK = `${getEnv("REACT_APP_KEYLNK")}`
export const PATH_LINK = `${getEnv("REACT_APP_PATH")}`

export const FOOTER_VERSION = `${getEnv("REACT_APP_VERSION")}`
export const PageDefault = MENU_HOME
export const PageDefaultProfile = PAGE_MYPROFILE

export const URL_WEB_V2 = 'http://localhost:5173'
export const USE_IS_BETA = false // ใช้สำหรับเปิดปิดการใช้งานฟีเจอร์ที่ยังไม่สมบูรณ์หรืออยู่ในช่วงทดสอบ

export const activeStyle = {
  backgroundColor: 'rgb(178 214 255)',
  color: '#ffff'
}

export const API_LARK_URL = `${getEnv("REACT_APP_API_LARK_URL")}`
export const AUTH_LARK_URL = `${getEnv("REACT_APP_API_LARK_AUTHEN")}`

export const GRAPHQL_API_URL = `${getEnv("REACT_APP_API_TRANSLATE_URL")}`
export const KEY_GOOGLE_MAP = `${getEnv("REACT_APP_GOOGLE_MAP")}`
export const LIBRARIES = ['geometry']
